<script>
import {  common } from '@/mixins/common';
import {
  GetApiActionWithAuthorization,
    GetApiActionWithAuthorizationOnly,
    PostApiWithAuthorizationAction
} from '../../../helpers/apiActions';
import moment from "moment-timezone";
import extractDate from 'extract-date';

export default {
  name: 'AddNewShowDrawerContent',
  components: {},
  props: {
    show: {
      type: Object,
      required: true
    },
    count: {
      type: Number,
      required: true
    },
    liveShowAccounts: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      submitted: false,
      form: {
        account: '',
        date: '',
        disableScheduleTime: false,
        time: '',
        id: '001',
        items: [],
        title: ''
      },
      itemSpecifics: [
        'Brand',
        'Style',
        'Type'
      ],
      albums: [],
      accounts: [
        {
          value: 'NEVADA COIN MART'
        },
        {
          value: 'Neil Buys'
        },
        {
          value: 'Jewel Giant'
        }
      ],
      rules: {
        account: [
          { required: true, message: ' ', trigger: 'change' }
        ]
      }
    }
  },
  mixins: [
    common
  ],
  methods: {
    loadProductItemSpecifics(categoryId) {
      let _vm = this;
      _vm.loadingProductFormSpecific = true;
      return GetApiActionWithAuthorization(
        "admin/products/load-full-single-product-item-specifics/" + categoryId
      )
        .then((data) => {
          if (data.status == "success") {
            _vm.itemSpecifics = data.data;
            _vm.productItemSpecifics = data.data
              .map((i) => {
                i.formValue = _vm.productDetail.parameters[i.value];
                return i;
              })
              .reduce(
                (obj, itm) => Object.assign(obj, { [itm.value]: itm.formValue }),
                {}
              );
          } else {
            throw new Error(data.message);
          }
        })
        .catch((error) => {
          // eslint-disable-next-line
          console.log(error);
        });
    },
    setProductCategory() {
      let selectedCategory = this.form.selectedCategory;
      this.$root.$emit("load-item-specific-fields", selectedCategory);
      this.form.selectedCategory = "";
      this.loadCategories(selectedCategory);
    },
    changeProductCategory(i, categoryId) {
      this.form.items[i].category = "";
      this.loadCategories(i, categoryId);
    },
    loadCategories(i, categoryId = null) {
      let _vm = this,
        params = {},
        url = "admin/ebay-services/get-build-show-categories?requestPage=liveShow";
      if (categoryId == null) {
        categoryId = _vm.form.items[i].category;
      }
      //
      params.categoryId = categoryId;
      return PostApiWithAuthorizationAction(url, params).then((res) => {
        if (res.status === "success") {
          _vm.form.items[i].categories = res.data;
          //
          if (res.children.length == 0) {
            _vm.form.items[i].category = categoryId;
          }
          if (categoryId == -1) {
            _vm.form.items[i].category = "";
          }
        }
      });
    },
    resetCategories(index) {
      this.loadCategories(index, -1);
    },
    loadAlbums () {
        let _vm = this
        return GetApiActionWithAuthorizationOnly("admin/products/live-show/get-albums").then(res => {
            _vm.albums = res.data
        });
    },
    formatNumber (number) {
        return String(number).padStart(3, '0')
    },
    submitForm() {
        let _vm = this
        _vm.$refs.formContainer.validate((valid) => {
            if (valid) {
              _vm.submitted = true
              let form = _vm.form
              let submitUrl = (_vm.show.id === 0)
                                ? process.env.VUE_APP_BACKEND_APP_URL + "admin/products/live-show/create-show"
                                : process.env.VUE_APP_BACKEND_APP_URL + "admin/products/live-show/edit-show/" + _vm.show.id
              //
              // eslint-disable-next-line
              console.log(form.time)
              return PostApiWithAuthorizationAction("", {
                ... form,
                date: form.date.split(' ')[0],
                time: (form.time.length == 8) ? form.time : moment(form.time).format('HH:mm:ss')
              }, {
                url: submitUrl
              }).then(res => {
                if (res.status == 'success') {
                    /*if (res.data.uploadedFileUrl)
                        window.open(res.data.uploadedFileUrl, '');*/
                    location.href = '/products/live-show/index?tab=shows'
                }
                _vm.submitted = false
              }).catch(error => {
                // eslint-disable-next-line
                console.log(error)
                _vm.submitted = false
              })
            }
        });
    },
    addNewItem () {
        const _vm = this
        const i = _vm.form.items.length
        _vm.form.items.push({
            album: '',
            category: '-1',
            itemCount: 1,
            categories: [
                {
                    value: "-1",
                    data: []
                }
            ],
            itemSpecifics: {}
        })
        _vm.loadCategories(i, _vm.form.items[i].category)
    },
    removeItem (index) {
        const _vm = this
        _vm.form.items = _vm.form.items.filter((v, i) => i !== index)
    }
  },
  computed: {
    todayDate () {
      return moment().add(1, 'day').format('YYYY-MM-DD h:mm:ss')
    },
    scheduledDate () {
      return moment().add(1, 'day').format('M/D/YY')
    }
  },
  mounted () {
    let _vm = this;
    _vm.loadAlbums()
    _vm.form.date = moment().add(1, 'day').format('YYYY-MM-DD h:mm:ss')
    _vm.form.time = (new Date())
    _vm.form.title = 'AS SHOWN ON SCREEN OFFICIAL {ACCOUNT} EBAY LIVE SHOW ' + _vm.scheduledDate.split(' ')[0].replaceAll('-', '/')
    if (_vm.form.items.length === 0) {
      _vm.form.items.push({
        album: '',
        category: '-1',
        itemCount: 1,
        categories: [
          {
            value: "-1",
            data: []
          }
        ],
        itemSpecifics: {
          Brand:'',
          Style:'',
          Type:''
        }
      })
      //
      _vm.loadCategories(0, _vm.form.items[0].category)
    }
  },
  watch: {
    'form.account': function(val) {
      let title = this.form.title
      const _vm = this
      //
      for (let account of _vm.accounts) {
        title = title.replace(account.value, '{ACCOUNT}')
      }
      //
      if (val) {
        let account = _vm.liveShowAccounts.find(v=>v.id == val)
        _vm.form.title = title.replace('{ACCOUNT}', account.liveShowSlug.trim())
      }
    },
    'form.disableScheduleTime': function(val) {
      if (val)
        this.form.date = moment().format('YYYY-MM-DD h:mm:ss')
    },
    'form.date': function (val) {
      const _vm = this
      const match = extractDate(_vm.form.title, {direction: 'MD'})
      let dates = match[0].date.slice(2).replaceAll('-', '/').split('/')
      const date = Number(dates[1]) + '/' + Number(dates[2]) + '/' + dates[0]
      _vm.form.title = _vm.form.title.replace(date, moment(val).format("M/D/YY"))
    }
  }
}
</script>

<template>
<div class="px-2" style="overflow: hidden">
    <el-form
        :model="form"
        @submit.native.prevent="submitForm"
        ref="formContainer"
        id="showDrawerForm">
      <div class="box-section my-3 pb-1">
        <div class="box-section-header">GENERAL SETTING</div>
        <div class="box-section-body py-2">
          <div class="drop-schedule-checkbox">
            <el-checkbox
              v-model="form.disableScheduleTime">Submit Immediatly ?</el-checkbox>
          </div>
          <b-row>
            <b-col cols="5">
              <el-form-item
                class="mb-2"
                :rules="rules.account"
                prop="account">
                  <label
                      class="mb-0"
                      style="display: block;line-height: 15px;">Account</label>
                  <el-select
                      v-model="form.account"
                      placeholder="# Account"
                      size="medium"
                      style="width: 100%"
                      >
                      <el-option
                          v-for="(account, index) in liveShowAccounts"
                          :key="index"
                          :label="account.liveShowSlug"
                          :value="account.id"
                      ></el-option>
                  </el-select>
              </el-form-item>
            </b-col>
            <b-col cols="3" class="px-0" v-if="!form.disableScheduleTime">
              <el-form-item class="mb-0">
                  <label
                      class="mb-0"
                      style="display: block;line-height: 15px;">Schedule Time</label>
                  <el-date-picker
                      v-model="form.date"
                      type="date"
                      placeholder="Choose Date"
                      style="width: 100%"
                      :default-value="form.date"
                      value-format="yyyy-MM-dd"
                      >
                      </el-date-picker>
              </el-form-item>
            </b-col>
            <b-col cols="3" v-if="!form.disableScheduleTime">
              <el-form-item class="mb-0">
                <label class="mb-0" style="display: block;line-height: 15px;">&nbsp;</label>
                <el-time-picker
                  v-model="form.time"
                  style="width: 100%"
                  placeholder="Choose Time"
                  value-format="HH:mm:ss">
                </el-time-picker>
              </el-form-item>
            </b-col>
          </b-row>
        <el-form-item
          class="mb-2"
          prop="account">
            <label
                class="mb-0"
                style="display: block;line-height: 15px;">Custom Ordering</label>
              <el-input
                placeholder=""
                v-model="form.customProductTitleBegin"
                style="width: 40%;"
                size="medium">
              </el-input>
        </el-form-item>
        <el-form-item
          class="mb-2"
          :rules="rules.account"
          prop="account">
            <label
                class="mb-0"
                style="display: block;line-height: 15px;">Custom Title</label>
              <el-input
                placeholder=""
                v-model="form.title"
                style="width: 100%;"
                autofocus="autofocus"
                size="medium">
              </el-input>
        </el-form-item>
    </div>
    </div>
      <div class="box-section my-3 pb-1">
        <div class="box-section-header">PRODUCTS GENERATE SETTING</div>
        <div class="box-section-body py-2">
        <div class="">
            <!--b-row class="b-table">
                <b-col cols="3" class="py-2 column-header">ALBUM</b-col>
                <b-col cols="7" class="py-2 column-header text-center">CATEGORY</b-col>
                <b-col cols="2" class="py-2 column-header">ITEM COUNT</b-col>
            </b-row-->
            <div
              v-for="(item, index) in form.items"
              :key="index"
              style="border-bottom: 2px dashed #918e8e;"
              class="mb-1">
            <b-row>
                <b-col cols="4" class="pb-2">
                  <label
                      class="mb-0"
                      style="display: block;line-height: 15px;">Album</label>
                    <el-select
                        v-model="item.album"
                        placeholder="# Album"
                        size="medium"
                        style="width: 100%"
                        >
                        <el-option
                            v-for="(album, index) in albums"
                            :key="index"
                            :label="album.title"
                            :value="album.id"
                        ></el-option>
                    </el-select>                    
                </b-col>
                <b-col
                    cols="8"
                    class="pb-2">
                    <b-row>
                        <b-col cols="4">
                          <label
                              class="mb-0"
                              style="display: block;line-height: 15px;">Item Count</label>
                            <el-input
                                placeholder=""
                                v-model="item.itemCount"
                                size="medium">
                            </el-input>
                        </b-col>
                        <b-col cols="6" class="px-0">
                  <label
                      class="mb-0"
                      style="display: block;line-height: 15px;">Category</label>
                        <el-select
                            v-model="item.category"
                            placeholder="--- SELECT CATEGORY ---"
                            size="medium"
                            style="width: 100%;"
                        >
                            <el-option
                                v-for="(category, __index) in item.categories"
                                :key="__index"
                                :label="category.categoryName + (category.leafCategory == 0 ? ' >' : '')"
                                :value="category.categoryID"
                                ></el-option>
                        </el-select>
                        </b-col>
                        <b-col cols="2" class="text-right">
                  <label
                      class="mb-0"
                      style="display: block;line-height: 15px;">&nbsp;</label>
                            <el-button
                                type="danger"
                                size="small"
                                v-if="index > 0"
                                @click="removeItem(index)"
                                circle>
                                <i class="el-icon-close font-size-16"></i>
                            </el-button>
                        </b-col>
                    </b-row>
                </b-col>
            </b-row>
            <b-row>
              <b-col cols="12" class="pb-2">
                <div class="mt-0">
                  <b-row>
                    <b-col
                      v-for="(itemSpecific, i) in itemSpecifics"
                      :key="i"
                      cols="3">
                      <label
                          class="mb-0"
                          style="display: block;line-height: 15px;">{{ itemSpecific }}</label>
                      <el-input
                        placeholder=""
                        v-model="form.items[index].itemSpecifics[itemSpecific]"
                        size="medium">
                      </el-input>
                    </b-col>
                  </b-row>
                </div>
              </b-col>
            </b-row>
          </div>
        </div></div>
            <el-button
                type="success"
                size="mini"
                @click="addNewItem()"
                circle>
                <i class="bx bx-plus-circle font-size-18"></i>
            </el-button>
        </div>
        <div class="mt-2 text-right">
            <el-button
                type="primary"
                native-type="submit"
                :disabled="submitted">
                SUBMIT
            </el-button>
        </div>
    </el-form>
</div>
</template>
<style scoped>
.drop-schedule-checkbox {
  position: absolute;
  right: 40px;
  top: 75px;
}
.b-table {
    background-color: rgba(0, 0, 0, 0.05);
    border: 5px solid #5b5f70;
    border-right: none;
    border-left: none
}
.column-header {
    color: white;
    font-weight: bold;
    background: #707070;
}
.box-section-body label {
  font-size: 14px;
}
</style>
<style>
.el-upload-list--picture-card .el-upload-list__item,
.el-upload.el-upload--picture-card {
  width: 100px;
  height: 100px;
}
.el-upload--picture-card .el-upload-dragger {
  width: 100% !important;
  height: 100% !important;
}
.el-upload--picture-card {
  line-height: 100px;
}
#showDrawerForm .el-input--prefix .el-input__inner {
    padding-left: 30px !important;
}
#showDrawerForm .el-input--suffix .el-input__inner {
    padding-right: 30px !important;
}
</style>
